import Image from 'next/image'
import { SearchResultsProps } from '@interfaces/header'
import assetLoader, { s3UrlLoader } from '@utils/assetloader'
import { toKebabCase } from '@utils/stringUtils'
import LoadingState from './LoadingState'
import NoResultsState from './NoResultState'
import styles from './SearchComponent.module.scss'

const SearchResults = ({
  searchResults,
  searchQuery,
  activeTab,
  onItemClick,
  variant,
  isLoading,
}: SearchResultsProps & { isLoading: boolean }) => {
  if (isLoading) {
    return <LoadingState />
  }

  if (!searchResults) {
    return null
  }

  const currentData = activeTab === 'cars' ? searchResults.carsData || [] : searchResults.blogsData || []

  if (searchQuery.trim() && currentData.length === 0) {
    return <NoResultsState activeTab={activeTab} searchQuery={searchQuery} variant={variant} />
  }

  if (currentData.length === 0) {
    return null
  }

  const isBrandCollection = (item: any) => item.name?.toLowerCase().includes('all ') || item.name?.toLowerCase().includes(' cars') || !item.model_name

  return (
    <div className={styles.sectionSearchResult}>
      <p className={styles.sectionTitle}>
        {!searchQuery.trim() ? (activeTab === 'cars' ? 'Recommended Cars' : 'Latest Articles') : 'Search Results'}
      </p>
      {currentData.map((item: any, index: number) => (
        <div key={index} className={styles.resultItem} onClick={() => onItemClick(item)}>
          {activeTab === 'cars' ? (
            <div className={styles.carItem}>
              <Image
                src={
                  isBrandCollection(item)
                    ? `${assetLoader()}/icons/${variant === 'desktop' ? 'car-brands-light' : 'car-brands-dark'}/${
                        item.make_name
                      }.svg`
                    : `${s3UrlLoader()}/${toKebabCase(item.make_name)}/${toKebabCase(
                        item.model_name
                      )}/default/Hero-Transparent.png`
                }
                alt={item.name}
                width={48}
                height={48}
                className={styles.carImage}
                loading="lazy"
              />
              <span>{item.name}</span>
            </div>
          ) : (
            <div className={styles.blogItem}>
              <Image
                src={item.image_url || '/images/image1.png'}
                alt={item.name}
                width={variant === 'desktop' ? 96 : 48}
                height={48}
                className={styles.blogImage}
                loading="lazy"
              />
              <div className={styles.blogInfo}>
                <span className={styles.blogTitle}>{item.name}</span>
                {item.published_date && <span className={styles.blogDate}>{item.published_date}</span>}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default SearchResults
